/*
	This script is used on:
	https://www.shipstation.com/lp/walmart/
*/
import { partnersAppIntegrationModule, onSignupFormReady } from '../partners';

// Set up our constants that our module extends to the partner landing pages.
let registerServer = partnersAppIntegrationModule.partnerLpAppSettings.registerServer;
const oauthRoute = "/api/datadriven/oauth/accept/ordersource/walmart"
const registerEndpoint = partnersAppIntegrationModule.partnerLpAppSettings.registerEndpoint;
const optinConsentCountries = partnersAppIntegrationModule.partnerLpAppSettings.optinConsentCountries;

let country = partnersAppIntegrationModule.getHomeCountry();

let buttonText = "START YOUR FREE TRIAL!";

// Capture Walmart OAuth parameters from the URL
const walmartCallbackUri = partnersAppIntegrationModule.getParameterByName('walmartCallbackUri');
const clientType = partnersAppIntegrationModule.getParameterByName('clientType');

// Bind to the LIVE form after Vue rebuilds it, not on the racy $(document).ready. See onSignupFormReady in ../partners.js.
onSignupFormReady(function () {
	// Handle the "How did you hear about us?" dropdown.
	partnersAppIntegrationModule.ss_handleHowDidYouHearAboutUs();

	$("#country").val(country);

	// fix for Smartling -- stores the initial value of the register button for resetting after load state
	buttonText = $("#register-button").val();

	$.cookie("referral_code", "partner-walmart", {
		domain: ".shipstation.com",
		expires: 30,
		path: "/",
	});

    // Check if input #experiments exist and update with our GA data.
    partnersAppIntegrationModule.checkIfExperimentsExist();

	// Add journey_id hidden field to the form if it doesn't exist, then capture YOFI journey_id
	if (!$('#journey_id').length) {
		$('#registration-form').append('<input type="hidden" id="journey_id" name="journey_id" value="" />');
	}
	partnersAppIntegrationModule.captureJourneyId('#journey_id');

	// Store Walmart OAuth params as hidden fields so they persist through registration
	if (walmartCallbackUri) {
		$('#registration-form').append('<input type="hidden" id="walmart_callback_uri" name="walmart_callback_uri" value="' + encodeURIComponent(walmartCallbackUri) + '" />');
	}
	if (clientType) {
		$('#registration-form').append('<input type="hidden" id="walmart_client_type" name="walmart_client_type" value="' + encodeURIComponent(clientType) + '" />');
	}

	$("a#loginButton,.loginButton").click(function (e) {
		e.preventDefault();
		let loginUrl = 'https://ship.shipstation.com/login'
		const loginParams = [];
		loginParams.push('marketplace=walmart');;
		if (walmartCallbackUri) {
			loginParams.push('walmartCallbackUri=' + encodeURIComponent(walmartCallbackUri));
		}
		if (clientType) {
			loginParams.push('clientType=' + encodeURIComponent(clientType));
		}
		if (loginParams.length) {
			loginUrl += '?' + loginParams.join('&');
		}
		window.location = loginUrl;
	});
	$("#affiliate").val("Walmart");
	$("#hubspot_cookie").val($.cookie("hubspotutk"));
	$("#utcoffset").val(new Date().getTimezoneOffset() * -1);

	const messages = {
		US: {
		"password-confirm": {
			equalTo: "Passwords do not match",
			required: "Please confirm your password",
		},
		password: {
			required: "A password is required",
			minlength: "Passwords must be at least 7 characters",
		},
		"answers[0]": {
			required: "Please answer How did you hear about us?",
		},
		},
		DE: {
		"password-confirm": {
			equalTo: "Passwörter stimmen nicht überein",
			required: "Bitte bestätigen Sie Ihr Passwort",
		},
		password: {
			required: "Ein Passwort ist erforderlich",
			minlength: "Passwörter müssen mindestens 7 Zeichen lang sein",
		},
		"answers[0]": {
			required: "Bitte antworten Sie Wie haben Sie von uns erfahren?",
		},
		email: {
			required: "Dieses Feld ist erforderlich",
		},
		firstName: {
			required: "Dieses Feld ist erforderlich",
		},
		lastName: {
			required: "Dieses Feld ist erforderlich",
		},
		tos: {
			required: "Dieses Feld ist erforderlich",
		},
		},
	};

	$("#registration-form").append(
		'<input type="hidden" id="registration_channel" name="registration_channel" value="walmart" />'
	);

	if (typeof emailBlacklistEnabled !== 'undefined' && emailBlacklistEnabled && typeof emailBlacklistDomains !== 'undefined') {
		$.validator.addMethod("emailBlacklist", function(value, element) {
			if (!value) return true;
			var domain = value.split('@')[1];
			if (!domain) return true;
			domain = domain.toLowerCase();
			return !emailBlacklistDomains.some(function(pattern) {
				pattern = pattern.toLowerCase();
				if (pattern.endsWith('.*')) {
					var base = pattern.slice(0, -2);
					return domain.startsWith(base + '.');
				}
				return domain === pattern;
			});
		}, typeof emailBlacklistMessage !== 'undefined' ? emailBlacklistMessage : "Please enter a valid business email address");
	}

	$("#registration-form").validate({
		rules: {
		password: {
			minlength: 7,
		},
		"password-confirm": {
			equalTo: "#password",
		},
		"answers[0]": {
			required: true,
		},
		},
		messages: messages[partnersAppIntegrationModule.getHomeCountry()] || messages["US"], // Validation messages are initialized only at start
		submitHandler: function (form) {
		$("#register-button")
			.attr("disabled", "disabled")
			.css("background-color", "#ddd")
			.val("One Moment...");
		partnersAppIntegrationModule.updateTargetAppAtSubmission();



		$.post(registerEndpoint, $(form).serialize(), function (resp) {
			if (resp.success) {
			if (resp.userId && resp.username) {
				$.cookie("auth", resp.authToken, {
				domain: ".shipstation.com",
				path: "/; SameSite=Lax; Secure",
				});

				// Set email cookie
				const { host } = window.location;
				const domain = host.includes("shipstation")
				? `.shipstation${host.split("shipstation").pop()}`
				: host;
				document.cookie = `signup_email=${resp.username}; path=/; domain=${domain}; samesite=none; secure;`;

				const browserLanguage = navigator.language.toLowerCase() || "en-us";

				const currentUnixTimestamp = Date.now();
				// Modulo used to convert to midnight date format for hubspot
				const trialActivationDate =
				currentUnixTimestamp -
				(currentUnixTimestamp % 86400000) +
				86400000;
				const trialEndDate = resp.trialEndDate
				? resp.trialEndDate - (resp.trialEndDate % 86400000)
				: "";

				dataLayer.push({
				event: "account_created", // hardcoded
				userId: resp.userId,
				email: resp.username,
				orderId: resp.refno,
				home_country: $("#country").val(),
				affiliate: $("#affiliate").val() || "",
				referrer: $("#referrer").val() || "",
				referral_code: $("#referral_code").val() || "",
				coupon: $("#coupon").length ? $("#coupon").val() : "",
				phonenumber: $("input[name=phone]").val() || "",
				company: $("#reg-compname").val() || "",
				howdidyouhearaboutus: $("#howdidyouhearaboutus").length
					? $("#howdidyouhearaboutus").val()
					: "",
				shipment_volume: $("#shipment_volume").length
					? $("#shipment_volume").val()
					: "",
				});

				// Segment identify and track for Account Created
				partnersAppIntegrationModule.trackSegmentAccountCreated(resp, $("#country").val());

				// send to hubspot
				$.get("https://www.shipstation.com/hubspot/form-api.php", {
				pageName: document.title,
				pageURL: window.location.href,
				refno: resp.refno,
				email: resp.username,
				userId: resp.userId,
				firstname: $("#reg-fname").val() || "",
				lastname: $("#reg-lname").val() || "",
				howdidyouhearaboutus: $("#howdidyouhearaboutus").length
					? $("#howdidyouhearaboutus").val()
					: "",
				vat_number: $("input[name=vat_number]").length
					? $("input[name=vat_number]").val()
					: "",
				optin_consent: optinConsentCountries.includes(
					$("#countryCode").val()
				)
					? $("input[name=optin_consent]:checked").val()
					? "yes"
					: "no"
					: "",
				home_country: $("#country").val(),
				referral_code: $("#referral_code").length
					? $("#referral_code").val()
					: "",
				coupon: $("#coupon").length ? $("#coupon").val() : "",
				verified: resp.verified || "",
				trialActivationDate: trialActivationDate,
				trialEndDate: trialEndDate,
				browserLanguage: browserLanguage,
				utcOffsetInMinutes: $("#utcoffset").val(),
				isDST: window.luxon
					? window.luxon.DateTime.local().isInDST
					: null,
				shipment_volume: $("#shipment_volume").length
					? $("#shipment_volume").val()
					: "",
				device_type: $("#device_type").val() || "",
				targetApp: $("#targetApp").length ? $("#targetApp").val() : "default",
				});
			}

			setTimeout(function () {
				// Build the redirect URL with Walmart OAuth params
				let redirectUrl = registerServer + oauthRoute;
				const params = [];
				if (walmartCallbackUri) {
					params.push('walmartCallbackUri=' + encodeURIComponent(walmartCallbackUri));
				}
				if (clientType) {
					params.push('clientType=' + encodeURIComponent(clientType));
				}
				if (params.length) {
					redirectUrl += '?' + params.join('&');
				}
				window.location = redirectUrl;
			}, 1000);
			} else {
			window.alert(resp.message);
			$("#register-button")
				.removeAttr("disabled")
				.css("background-color", "")
				.val(buttonText);
			}
		});
		},
	});

	if (typeof emailBlacklistEnabled !== 'undefined' && emailBlacklistEnabled) {
		$("#email").rules("add", { emailBlacklist: true });
	}
});
